import { useState } from "react";
import { AuthProvider, useAuth } from "./context/AuthContext";
import NuevoPedido from "./pages/vendedora/NuevoPedido";
import MisPedidos from "./pages/vendedora/MisPedidos";
import PanelProduccion from "./pages/produccion/PanelProduccion";
import PanelJefe from "./pages/dueno/PanelJefe";
import PanelSuperAdmin from "./pages/superadmin/PanelSuperAdmin";

function Dashboard() {
  const { user, logout } = useAuth();
  const [vista, setVista] = useState("nuevo");

  const renderPanel = () => {
    switch (user?.rol) {
      case "superadmin":
        return <PanelSuperAdmin />;
      case "vendedora":
        return vista === "pedidos" ? <MisPedidos /> : <NuevoPedido />;
      case "dueno":
        return <PanelJefe />;
      case "produccion":
        return <PanelProduccion />;
      default:
        return <NuevoPedido />;
    }
  };

  if (user?.rol === "superadmin") {
    return <PanelSuperAdmin />;
  }

  if (user?.rol === "dueno") {
    return <PanelJefe />;
  }

  return (
    <div>
      <div className="bg-gradient-to-r from-[#0F1F4D] to-[#1A56DB] px-4 py-2 flex items-center justify-between sticky top-0 z-50 shadow-md">
        <div className="flex items-center gap-3">
          <img
            src="/logobancher.png"
            alt="Bancher"
            className="w-10 h-10 object-contain rounded-lg bg-white/10 p-1"
          />
          <span className="text-white font-semibold text-sm tracking-wide">
            BANCHER
          </span>
          {user?.rol === "vendedora" && (
            <div className="flex gap-1 ml-2">
              <button
                onClick={() => setVista("nuevo")}
                className={`text-xs px-3 py-1.5 rounded-lg font-medium transition-all ${vista === "nuevo" ? "bg-white text-[#1A56DB]" : "text-blue-100 hover:bg-white/10"}`}
              >
                + Nuevo
              </button>
              <button
                onClick={() => setVista("pedidos")}
                className={`text-xs px-3 py-1.5 rounded-lg font-medium transition-all ${vista === "pedidos" ? "bg-white text-[#1A56DB]" : "text-blue-100 hover:bg-white/10"}`}
              >
                Pedidos
              </button>
            </div>
          )}
        </div>
        <div className="flex items-center gap-3">
          <span className="text-blue-200 text-xs hidden sm:block">
            {user?.nombre}
          </span>
          <button
            onClick={logout}
            className="text-xs text-blue-200 hover:text-white transition-all px-2 py-1 rounded hover:bg-white/10"
          >
            Salir
          </button>
        </div>
      </div>
      {renderPanel()}
    </div>
  );
}

function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#F1F4F9] flex items-center justify-center">
        <div className="flex items-center gap-3 text-[#1A56DB]">
          <div className="w-5 h-5 border-2 border-[#1A56DB] border-t-transparent rounded-full animate-spin"></div>
          <span className="text-sm font-medium">Cargando...</span>
        </div>
      </div>
    );
  }

  return user ? <Dashboard /> : <Login />;
}

function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError("Usuario o contraseña incorrectos");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0A1128] via-[#0F1F4D] to-[#1A56DB] flex items-center justify-center p-4 relative overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-blue-500/20 rounded-full blur-3xl pointer-events-none" />

      <div className="relative bg-white/95 backdrop-blur-xl border border-white/20 rounded-2xl p-8 w-full max-w-md shadow-2xl">
        <div className="text-center mb-8">
          <div className="w-40 h-40 mx-auto -mb-14">
            <img
              src="/logo-rivaldy.png"
              alt="Rivaldy"
              className="w-full h-full object-contain drop-shadow-xl"
            />
          </div>
          <h1 className="text-2xl font-bold bg-gradient-to-r from-[#0F1F4D] to-[#1A56DB] bg-clip-text text-transparent">
            Rivaldy
          </h1>
          <p className="text-xs text-gray-400 mt-1 uppercase tracking-widest font-medium">
            Sistemas de SaaS
          </p>
          <div className="w-12 h-0.5 bg-gradient-to-r from-[#1A56DB] to-[#3B82F6] mx-auto mt-3 rounded-full" />
        </div>
        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <label className="text-xs text-gray-500 uppercase tracking-widest font-medium">
              Usuario
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tu@correo.cl"
              className="w-full mt-1 bg-[#F1F4F9] border border-[#E5E9F0] rounded-lg px-4 py-3 text-gray-900 text-sm focus:outline-none focus:border-[#1A56DB] focus:ring-1 focus:ring-[#1A56DB] transition-all"
            />
          </div>
          <div>
            <label className="text-xs text-gray-500 uppercase tracking-widest font-medium">
              Contraseña
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="w-full mt-1 bg-[#F1F4F9] border border-[#E5E9F0] rounded-lg px-4 py-3 text-gray-900 text-sm focus:outline-none focus:border-[#1A56DB] focus:ring-1 focus:ring-[#1A56DB] transition-all"
            />
          </div>
          {error && (
            <div className="bg-red-50 border border-red-200 rounded-lg px-4 py-3 text-red-600 text-sm">
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-gradient-to-r from-[#0F1F4D] to-[#1A56DB] hover:from-[#0A1837] hover:to-[#1544B0] text-white font-semibold py-3 rounded-lg transition-all disabled:opacity-50 text-sm shadow-lg shadow-blue-500/30"
          >
            {loading ? "Ingresando..." : "Ingresar"}
          </button>
        </form>
        <p className="text-center text-xs text-gray-400 mt-6">
          Rivaldy © 2026 — Sistemas de gestión para negocios locales
        </p>
      </div>
    </div>
  );
}

export default function Root() {
  return (
    <AuthProvider>
      <App />
    </AuthProvider>
  );
}
